import { TIERED_HI_PLAN_GROUPS } from 'consts/hiToolsConsts'
import usePlanLimits from 'hooks/usePlanLimits'
import { useMemo } from 'react'

export const isTieredHIPlanForPlan = ({ grinPlanKey, grinPlanGroup, withScanTracking } = {}) =>
  !!withScanTracking && TIERED_HI_PLAN_GROUPS.includes(grinPlanGroup) && grinPlanKey !== 'grin-hi-limited'

export default ({ grinPlanKey, grinPlanGroup, withScanTracking } = {}) => {
  const planLimits = usePlanLimits()

  const resolvedPlanKey = grinPlanKey ?? planLimits.grinPlanKey
  const resolvedPlanGroup = grinPlanGroup ?? planLimits.grinPlanGroup
  const resolvedWithScanTracking = withScanTracking ?? planLimits.withScanTracking

  return useMemo(
    () =>
      isTieredHIPlanForPlan({
        grinPlanKey: resolvedPlanKey,
        grinPlanGroup: resolvedPlanGroup,
        withScanTracking: resolvedWithScanTracking
      }),
    [resolvedPlanGroup, resolvedPlanKey, resolvedWithScanTracking]
  )
}
